import { createContext } from 'react';

// Each pre-render uses its own collector; browser renders manage the head normally.
export const SEOContext = createContext(null);
